import { useSearchParams, useNavigate } from 'react-router-dom';
import { Button } from '@/components/atoms/Button';

/**
 * 토스페이먼츠 failUrl 콜백
 * URL: /premium/fail?code=xxx&message=yyy
 */
export function PremiumFailPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const code = params.get('code');
  const message = params.get('message');

  return (
    <div className="mx-auto max-w-md px-5 py-16 text-center">
      <div className="text-5xl">😢</div>
      <h1 className="mt-4 text-2xl font-bold">결제 실패</h1>
      {code && <p className="mt-2 text-xs text-[var(--color-text-sub)]">에러 코드: {code}</p>}
      {message && (
        <p className="mt-2 text-sm text-[var(--color-text-sub)]">{decodeURIComponent(message)}</p>
      )}
      <div className="mt-8 flex gap-2">
        <Button variant="secondary" fullWidth onClick={() => navigate('/')}>
          홈으로
        </Button>
        <Button fullWidth onClick={() => navigate('/premium')}>
          다시 시도
        </Button>
      </div>
    </div>
  );
}
